export default __webpack_public_path__ + "static/media/MCSW_Vision.d3a43b14.pdf";